// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"O1-z","shipmentMessage":"P1-z","shipmentNumber":"Q1-z","trackingProgressContainer":"R1-z"};